import Dialogo from '@/components/Dialogo';
import BlocoNotificacaoSom from '@/components/conversas/BlocoNotificacaoSom';
import BlocoSecoesInbox from '@/components/conversas/BlocoSecoesInbox';

/**
 * O painel da engrenagem: preferências DA PESSOA para a inbox.
 *
 * Dois assuntos, um lugar só. Uma segunda engrenagem para "seções" obrigaria a
 * pessoa a lembrar qual botão guarda qual ajuste — e ambos são a mesma coisa do
 * ponto de vista dela: como a lista se comporta para ela, neste navegador.
 *
 * Nenhum estado aqui: os dois hooks vivem na `ListaConversas`, que é quem
 * consome as preferências para desenhar. Este componente distribui.
 */
export default function PainelConfiguracoes({ aberto, aoFechar, som, secoes }) {
  return (
    <Dialogo titulo="Configurações" aberto={aberto} aoFechar={aoFechar} largura={480}>
      <div className="dialogo-corpo">
        <BlocoNotificacaoSom
          preferencias={som.preferencias}
          bloqueado={som.bloqueado}
          alternarGeral={som.alternarGeral}
          alternarEvento={som.alternarEvento}
          tocarTeste={som.tocarTeste}
        />

        <BlocoSecoesInbox
          preferencias={secoes.preferencias}
          mover={secoes.mover}
          alternarVisibilidade={secoes.alternarVisibilidade}
          tornarPadrao={secoes.tornarPadrao}
        />

        <div className="dialogo-acoes">
          <button type="button" className="btn-primario" onClick={aoFechar}>
            Fechar
          </button>
        </div>
      </div>
    </Dialogo>
  );
}
